module.exports = __webpack_public_path__ + "static/media/kantoushan1.7a02d30f.webp";